import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'hbh-ui-modules/dist/bundle.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/styles/index.scss';

import { authConfig, axios } from '@common/utils';
import { AuthProvider } from 'hbh-ui-modules';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider authConfig={authConfig} axiosInstance={axios}>
      <Router>
        <App />
      </Router>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
